// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import "./App.css";
import Router from "./router/Router";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useSelector } from "react-redux";
import FullScreenLoader from "./components/loaders/FullScreenLoader";
import FrameProtection from "./errorboundary/FrameProtection";
import { useEffect } from "react";
import environment from "./config/environment";

function App() {
  const { isLoading, handleItemLoading } = useSelector((state) => ({
    isLoading: state.isLoading,
    handleItemLoading: state.handleItemLoading,
  }));

  
  useEffect(() => {
    const metaTag = document.querySelector('meta[name="app-environment"]');
    if (metaTag) {
      metaTag.setAttribute("content", environment);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.name = "app-environment";
      newMetaTag.content = environment;
      document.head.appendChild(newMetaTag);
    }
  }, []);

  return (
    <div className="App">
      <FrameProtection />
      <DndProvider backend={HTML5Backend}>
        <Router />
        {isLoading && <FullScreenLoader />}
        {handleItemLoading && <FullScreenLoader />}
      </DndProvider>
    </div>
  );
}

export default App;